module.exports = __webpack_public_path__ + "img/MES1_Indice4_Sommaire.17cb1a85.png";